import PropTypes from 'prop-types';

import { CAMPAIGN_STATUS_CONFIG } from '../../constants/campaignStatuses';

export default function PostMailingStatusBadge({ status }) {
	const config = CAMPAIGN_STATUS_CONFIG[status] || CAMPAIGN_STATUS_CONFIG.draft;

	return (
		<span
			className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}
		>
			{config.animate && (
				<span className={`w-1.5 h-1.5 rounded-full animate-pulse ${config.dot || 'bg-caution-500'}`} />
			)}
			{config.label}
		</span>
	);
}

PostMailingStatusBadge.propTypes = {
	status: PropTypes.string.isRequired,
};
